import NIcon from './NIcon.vue';

export default NIcon;